import RewardSimpleForm from './RewardSimpleForm'

export default RewardSimpleForm
